import getFetchOptions from 'utils/getFetchOptions';
import {ENDPOINT_URL} from 'constants/index';

const COUNTRY = process.env.REACT_APP_COUNTRY || 'sweden';

export async function saveLanguageKey(locale, key, value, app = 'backoffice') {
	const response = await fetch(
		`${ENDPOINT_URL}/language-config`,
		getFetchOptions({
			method: 'POST',
			body: JSON.stringify({country: COUNTRY, app, locale, key, value}),
		})
	);
	if (!response.ok) throw new Error('Failed to save');
	return response.json();
}

export async function deleteLanguageKey(locale, key, app = 'backoffice') {
	const response = await fetch(
		`${ENDPOINT_URL}/language-config`,
		getFetchOptions({
			method: 'DELETE',
			body: JSON.stringify({country: COUNTRY, app, locale, key}),
		})
	);
	if (!response.ok) throw new Error('Failed to delete');
	return response.json();
}
